import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import config from '../../../config.json'
import OverlayTwoActionsComponent from '../presentational/OverlayTwoActionsComponent'
import { PROGRAM_MATCH_CANDIDATES } from '../../../constants/state'
import getData from '../../../functions/getData'
import actionTypes from '../../../actions/actionTypes'

const mapStateToProps = state => ({
    matchCandidatesCount: getData(state, [PROGRAM_MATCH_CANDIDATES, 'list']).size,
})

const mapDispatchToProps = dispatch => ({
    onDismiss: () => dispatch({ type: actionTypes.PROGRAM_FETCH_MATCH_OVERLAY_DISMISS }),
    onViewReport: () => {
        dispatch({ type: actionTypes.PROGRAM_FETCH_MATCH_OVERLAY_DISMISS })
        dispatch(push(config.routes.matchReport.path))
    },
})

const FetchMatchOverlayContainer = ({ matchCandidatesCount, onDismiss, onViewReport }) => (
    <OverlayTwoActionsComponent
        titleTransId="fetch_match_overlay_title"
        textTransId="fetch_match_overlay_text"
        textBefore={`${matchCandidatesCount} `}
        primaryButtonTransId="button_close"
        onPrimary={onDismiss}
        secondaryButtonTransId="fetch_match_overlay_button_report"
        onSecondary={onViewReport}
    />
)

export default connect(mapStateToProps, mapDispatchToProps)(FetchMatchOverlayContainer)
